export default __webpack_public_path__ + "static/media/K2D-ExtraBoldItalic.007e1233.ttf";